<template>
<div>
  <checkpoint-overview 
    :checkpoint="finding.checkpoint"
    :resolved="Boolean(finding.resolved_at)"
  />  
</div>  
</template>
<script>
import CheckpointOverview from '../../../components/CheckpointOverview.vue'

export default {
 
  components: { 
    CheckpointOverview 
  },
  
  props: {
    finding: {
      type: Object,
      default: () => ({})
    }
  }

}
</script>